export const SUB_LANGS = [
  { code: "ur", label: "Urdu" },
  { code: "hi", label: "Hindi" },
  { code: "en", label: "English" },
  { code: "ja", label: "Japanese" },
  { code: "ar", label: "Arabic" },
];
